
<template>
  <v-dialog v-model="dialog" scrollable persistent  max-width="800px" transition="dialog-transition">
    <v-card>
      <v-card-title>
        <span class="headline">Editando dados do cliente</span>
      </v-card-title>
      <v-card-text>
        <ClientInfoForm ref="form" :client="new_client"></ClientInfoForm>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <f-btn cancel text @click="closeDialog"></f-btn>
        <f-btn save @click="emitUpdate"></f-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import validations from "@/mixins/validations.js"

export default {
  name: 'ClientEditInfoDialog',
  mixins: [ validations ],
  props: {
    change_dialog:{
      type: Boolean,
      default: false,
    },
  },
  components:{
    ClientInfoForm: () => import("@/_backoffice/_registrations/components/client/register/forms/ClientInfoForm.vue"),
  },
  data() {
    return {
      dialog: false,
      new_client:{},
    }
  },
  methods: {
    emitUpdate(){
      if(this.$refs.form.validate()){
        this.$emit('update', {new_client: this.new_client, model: 'info'})
      }
    },
    closeDialog(){
      this.$emit('close')
    }
  },
  computed:{
    ...mapState({
      oneClient: state => state.Client.oneClient,
    })
  },
  watch:{
    change_dialog(nv, old){
      this.dialog = nv
    },
    dialog(nv, old) {
      if (nv) {
        var { id, name, fantasyName, corporateName, CPF, CNPJ, document, category, fixed_company_in_pix, attached_file_url } = this.oneClient?.data.attributes
        this.new_client = {
          id: id,
          name: name,
          fantasyName: fantasyName,
          corporateName: corporateName,
          CPF: CPF,
          CNPJ: CNPJ,
          category: category,
          fixed_company_in_pix,
          attached_file_url: attached_file_url
        }
      } else if (!nv) {
        this.new_client = {}
      }
    },
  }
}
</script>
